import { useState } from "react";

const RANGES = [
  { key: "today", label: "Today" },
  { key: "week", label: "This week" },
  { key: "month", label: "This month" },
  { key: "quarter", label: "This quarter" },
  { key: "fy", label: "This FY" },
  { key: "all", label: "All time" },
];

/**
 * Compute { from_date, to_date } (ISO YYYY-MM-DD) for a preset.
 * FY = Indian financial year (Apr - Mar).
 */
export function computeRange(key, custom) {
  const today = new Date();
  const iso = (d) => d.toISOString().slice(0, 10);
  const y = today.getFullYear();
  const m = today.getMonth(); // 0-indexed
  const d = today.getDate();
  const jsDay = today.getDay(); // 0 = Sun

  if (key === "today") return { from_date: iso(today), to_date: iso(today) };
  if (key === "week") {
    const start = new Date(today); start.setDate(d - jsDay); // Sunday start
    return { from_date: iso(start), to_date: iso(today) };
  }
  if (key === "month") return { from_date: `${y}-${String(m + 1).padStart(2, "0")}-01`, to_date: iso(today) };
  if (key === "quarter") {
    const qStart = Math.floor(m / 3) * 3;
    return { from_date: `${y}-${String(qStart + 1).padStart(2, "0")}-01`, to_date: iso(today) };
  }
  if (key === "fy") {
    const fyStart = m >= 3 ? y : y - 1;
    return { from_date: `${fyStart}-04-01`, to_date: iso(today) };
  }
  if (key === "custom" && custom) return custom;
  return { from_date: "", to_date: "" };
}

export default function DateRangeFilter({ value, onChange, className = "", testid = "date-filter" }) {
  const [customOpen, setCustomOpen] = useState(false);
  const active = value?.preset || "month";

  const pick = (k) => {
    if (k === "custom") { setCustomOpen(true); return; }
    onChange({ preset: k, ...computeRange(k) });
  };

  return (
    <div className={`inline-flex items-center gap-1 flex-wrap ${className}`} data-testid={testid}>
      {RANGES.map((r) => (
        <button
          key={r.key}
          onClick={() => pick(r.key)}
          data-testid={`${testid}-${r.key}`}
          className={`text-[11px] font-medium px-2.5 py-1 rounded-full border transition-colors ${
            active === r.key
              ? "bg-slate-900 text-white border-slate-900"
              : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
          }`}
        >
          {r.label}
        </button>
      ))}
      <button
        onClick={() => setCustomOpen((v) => !v)}
        className={`text-[11px] font-medium px-2.5 py-1 rounded-full border ${customOpen || active === "custom" ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}
      >
        Custom
      </button>
      {customOpen && (
        <div className="flex items-center gap-1 ml-1">
          <input
            type="date" value={value?.from_date || ""}
            onChange={(e) => onChange({ preset: "custom", from_date: e.target.value, to_date: value?.to_date || "" })}
            className="text-[11px] border border-slate-300 rounded px-1.5 py-0.5 bg-white"
          />
          <span className="text-slate-400 text-[11px]">→</span>
          <input
            type="date" value={value?.to_date || ""}
            onChange={(e) => onChange({ preset: "custom", from_date: value?.from_date || "", to_date: e.target.value })}
            className="text-[11px] border border-slate-300 rounded px-1.5 py-0.5 bg-white"
          />
        </div>
      )}
    </div>
  );
}
